import React, {useState} from 'react';

import {EXPORT_DISPLAY_NAME, ChemicalFileFormat} from 'chemistry/ChemistryConstants';
import * as FileUtil from 'folder-items/FileUtil';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Modal from 'ui-library/modals/Modal';
import * as net from 'util/Net';

type SupportedExportFormat = ChemicalFileFormat.SMILES | ChemicalFileFormat.MOL | ChemicalFileFormat.SDF;
const SUPPORTED_EXPORT_FORMATS: Array<SupportedExportFormat> = [
  ChemicalFileFormat.SMILES,
  ChemicalFileFormat.MOL,
  ChemicalFileFormat.SDF,
];

export interface ExportMoleculeModalProps {
  editURL: string;
  onRequestClose: () => void;
}

export default function ExportMoleculeModal(props: ExportMoleculeModalProps): JSX.Element {
  const [format, setFormat] = useState<SupportedExportFormat | null>(null);

  const handleDownload = (): void => {
    net.submitCSRFForm('POST', FileUtil.getExportURL(props.editURL, format!, {dl: true}), {target: '_blank'});
  };

  return (
    <Modal
      enableRedesign={true}
      title="Export Molecule"
      onRequestClose={props.onRequestClose}
      medium={true}
      buttons={[
        {
          text: 'Download',
          submit: true,
          style: 'success',
          disabled: format == null,
          onClick: handleDownload,
          dataTestAttrs: {component: 'ExportMoleculeModal', element: 'submit'},
        },
        {
          text: 'Cancel',
          onClick: props.onRequestClose,
        },
      ]}
    >
      <div className="form-group">
        <SelectDropdown
          displayName={format != null ? EXPORT_DISPLAY_NAME[format] : 'Choose Molecule Format...'}
          menu={
            <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
              {SUPPORTED_EXPORT_FORMATS.map((formatOption: SupportedExportFormat) => (
                <Option key={formatOption} value={formatOption} onSelect={setFormat}>
                  {EXPORT_DISPLAY_NAME[formatOption]}
                </Option>
              ))}
            </Menu>
          }
        />
      </div>
    </Modal>
  );
}
